import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { useAuthStore } from "@/stores/auth";

export async function authGuard(
  to: RouteLocationNormalized,
  _: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> {
  const authStore = useAuthStore();

  // Log de debug
  // console.log("GUARD:", {
  //   path: to.path,
  //   meta: to.meta,
  //   requiresAuth: to.meta?.requiresAuth,
  // });

  // Si la route a meta.requiresAuth === false, accès libre
  if (to.meta?.requiresAuth === false) {
    // console.log("GUARD: accès libre (public)");
    next();
    return;
  }

  // Sinon, authentification requise
  try {
    const isAuthenticated = await authStore.checkAuth();
    if (!isAuthenticated) {
      // console.log("GUARD: redirection vers /login (non authentifié)");
      next("/login");
      return;
    }
    // console.log("GUARD: accès autorisé (authentifié)");
    next();
  } catch (error: unknown) {
    console.error(
      "Erreur dans le garde de route:",
      error instanceof Error ? error.message : String(error)
    );
    next("/login");
  }
}
